export default __webpack_public_path__ + "static/media/illus-empty.5e5f0b43.svg";